import React, { createContext, useContext } from 'react';
import { effectiveSpelfase } from '../constants/game';

const AuctionContext = createContext();

export const useAuction = () => useContext(AuctionContext);

/**
 * De veiling waar de gebruiker in zit.
 *
 * De spelfase komt sinds kort van het seizoen: dat zet de standaard voor alle
 * subleagues, en een veiling mag daar zelf van afwijken. Om te voorkomen dat elke
 * pagina die afweging opnieuw moet maken, levert deze provider een `auction` waarin
 * `spelfase` al de effectieve waarde is. Wie het verschil moet zien — het
 * subleaguebeheer — heeft `seasonSpelfase` en `spelfaseIsAfwijking` tot zijn
 * beschikking.
 */
export const AuctionProvider = ({ children, auction, seasonSpelfase = '' }) => {
    const spelfase = effectiveSpelfase(auction, seasonSpelfase);

    const value = {
        auction: auction ? { ...auction, spelfase } : auction,
        auctionId: auction?.id,
        seasonSpelfase,
        spelfaseIsAfwijking: Boolean(auction?.spelfase),
    };

    return (
        <AuctionContext.Provider value={value}>
            {children}
        </AuctionContext.Provider>
    );
};
